import { useState, useEffect } from "react";
import axios from "axios";
// import projectsJSON from "../../assets/data/projects.json";
import ProjectCard from "../../components/ProjectCard";
const Index = () => {
	const [projects, setProjects] = useState(null);
	useEffect(() => {
		axios
			.get(
				`https://agne-portfolio-default-rtdb.europe-west1.firebasedatabase.app/.json`
			)
			.then((response) => {
				setProjects(response.data);
			})
			.catch((e) => {
				console.error(e);
			});
	}, []);
	if (!projects) {
		return (
			<div class="grid grid-cols-1">
				<span className="loading loading-spinner loading-lg place-self-center"></span>
			</div>
		);
	}
	const projectList = projects.map((project, i) => {
		return <ProjectCard key={i} project={project} />;
	});
	return (
		<>
			<h1 className="text-3xl text-center my-5 font-bold">All my projects</h1>
			<div className="grid grid-cols-2 justify-items-center">{projectList}</div>
		</>
	);
};
export default Index;
